import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Container, Row, Col, Button, Form, Badge } from 'react-bootstrap';
import MapView from './parts/MapView';
import UserService, { UserItem } from '#/services/UserService';
import { useForm, Controller } from 'react-hook-form';
import { useParams, useNavigate } from 'react-router-dom';
import DeviceService, { DeviceItem } from '#/services/DeviceService';
import { UserContext } from './App';
import { SpinnerView } from './parts/SpinnerView';

function OwnerModify() {
  const ctx = useContext(UserContext);
  const [admins, setAdmins] = useState<UserItem[]>();
  const [device, setDevice] = useState<Partial<DeviceItem>>();
  const { control, handleSubmit } = useForm();
  const { id } = useParams();
  const service = new DeviceService('owner', ctx.userInfo!);
  const navigate = useNavigate();

  useEffect(() => {
    if (ctx.userInfo!.role === 'superuser') {
      new UserService(ctx.userInfo!)
        .getList({
          group: 'admin',
        })
        .then(
          (res) => {
            setAdmins(res.data || []);
          },
          (e) => {
            if (e?.response.status === 401) {
              navigate(0);
            }
          }
        );
    } else {
      setAdmins([ctx.userInfo!]);
    }

    if (id) {
      service.getInfo(id!).then(
        (res) => {
          setDevice(res);
        },
        (e) => {
          if (e?.response.status === 401) {
            navigate(0);
          }
        }
      );
    } else {
      setDevice({
        location: {
          lat: 35.123,
          lon: 135.334,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFieldChange = useCallback(
    (value) => {
      setDevice({
        ...device!,
        ...value,
      });
    },
    [device]
  );

  const onLocationChange = (lat: number, lon: number) => {
    setDevice({
      ...device!,
      location: {
        lat,
        lon,
      },
    });
  };

  const onSubmit = (values: any) => {
    let response;
    if (id) {
      response = service.modifyDevice({
        ...values,
        type: 'owner',
        location: device!.location,
        device_id: device!.device_id,
        id: id,
      });
    } else {
      response = service.addDevice({
        ...values,
        type: 'owner',
        location: device!.location,
        device_id: device!.device_id,
        admin_id: device!.admin_id,
      });
    }

    response.then((_) => {
      // 一覧画面に遷移
      navigate('/owner');
    });
  };

  return (
    <Container fluid className="h-100 mt-4">
      <Row>
        <Col>
          <h3>親機{id ? '更新' : '登録'}</h3>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label>
                <Badge pill bg="danger" className="me-2">
                  必須
                </Badge>
                親機管理者 (Admin)
              </Form.Label>
              <Controller
                control={control}
                name="admin_id"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Select
                    aria-label="親機管理者"
                    onChange={(e) => {
                      onChange(e);
                      onFieldChange({ admin_id: e.target.value });
                    }}
                    value={device ? device.admin_id : ''}
                    ref={ref}
                    disabled={
                      !device || !admins || ctx.userInfo!.role !== 'superuser'
                    }
                  >
                    <option></option>
                    {admins ? (
                      admins.map((admin) => {
                        return (
                          <option value={admin.id} key={admin.id}>
                            {admin.name}
                          </option>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Form.Select>
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                <Badge pill bg="danger" className="me-2">
                  必須
                </Badge>
                識別ID
              </Form.Label>
              <Controller
                control={control}
                name="device_id"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="edit"
                    onChange={(e) => {
                      onChange(e);
                      onFieldChange({ device_id: e.target.value });
                    }}
                    value={device ? device.device_id : ''}
                    ref={ref}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="mb-5">
              <Form.Label>名称</Form.Label>
              <Controller
                control={control}
                name="name"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="edit"
                    onChange={(e) => {
                      onChange(e);
                      onFieldChange({ name: e.target.value });
                    }}
                    value={device ? device.name : ''}
                    ref={ref}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>設定位置</Form.Label>
              <div className="w-100" style={{ height: '500px' }}>
                {device ? (
                  <MapView
                    {...device!.location!}
                    onChange={onLocationChange}
                  ></MapView>
                ) : (
                  <></>
                )}
              </div>
            </Form.Group>
            <Form.Group className="text-center">
              <Controller
                control={control}
                name="name"
                render={({ field: { ref }, formState }) => (
                  <Button
                    type="submit"
                    variant="primary"
                    className="w-50"
                    ref={ref}
                    disabled={formState.isSubmitting}
                  >
                    {formState.isSubmitting ? (
                      <SpinnerView />
                    ) : id ? (
                      '更新'
                    ) : (
                      '登録'
                    )}
                  </Button>
                )}
              />
            </Form.Group>
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default OwnerModify;
